"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodNames = exports.PaymentMethodLabels = exports.PaymentMethod = exports.PaymentMethods = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.PaymentMethods = ['CREDIT_CARD', 'CASH', 'ACH', 'CHECK', 'WIRE', 'BILL_PAY'];
exports.PaymentMethod = typebox_1.Type.Union(exports.PaymentMethods.map((method) => typebox_1.Type.Literal(method)));
exports.PaymentMethodLabels = {
    CREDIT_CARD: 'Credit Card',
    CASH: 'Cash',
    ACH: 'ACH',
    CHECK: 'Check',
    WIRE: 'Wire Transfer',
    BILL_PAY: 'Bill Pay',
};
/**
 * @deprecated use PaymentMethodLabels instead
 */
exports.PaymentMethodNames = exports.PaymentMethodLabels;
//# sourceMappingURL=payment-method.js.map